export const SELECTED_RECORDS_FOR_STACKED_KEY = 'selected-records';
export const STACKED_DRAWER_KEY = 'stacked-drawer';
